import {defineStore} from "pinia";
import axios from "axios";
export const useLang = defineStore('lang',{
    state : () => ({
         prefix : localStorage.getItem('locale') ?? 'ckb',
         myPrefix : localStorage.getItem('myPrefix') ?? 'ku',
         filterPanel : false,
    }),
    actions: {
        async changeLang(locale){
            this.prefix = locale.prefix
            this.myPrefix = locale.my_prefix
            localStorage.setItem('locale',locale.prefix)
            localStorage.setItem('myPrefix',locale.my_prefix)
            await axios.get(route('language', locale.prefix));
        },
        changeFilter(filter){
            this.filterPanel = !filter;
        }
    }
});
